var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2H12.5V6H16.5V18H2.5V2ZM1.4985 0C0.94749 0 0.5 0.44405 0.5 0.9918V19.0082C0.5 19.5447 0.94476 20 1.4934 20H17.5066C18.0551 20 18.5 19.5489 18.5 18.9925L18.4997 5L13.5 0H1.4985ZM7.9999 5.5C7.9999 7.07749 7.5442 8.9373 6.77493 10.6534C6.00287 12.3757 4.96143 13.8502 3.87524 14.7191L5.05464 16.3321C7.9821 14.3804 11.2233 13.0421 14.3585 13.49L14.8162 11.5513C12.1435 10.6604 9.9999 7.98994 9.9999 5.5H7.9999ZM8.5999 11.4716C8.8673 10.8752 9.1042 10.2563 9.3037 9.6285C9.7753 10.3531 10.3553 11.0182 11.0101 11.5953C10.0283 11.7711 9.0665 12.0596 8.1352 12.4276C8.2999 12.1143 8.4551 11.7948 8.5999 11.4716Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePdf);
export default __webpack_public_path__ + "static/media/WhitePDF.cf496f2a48444a571d3ad49d27f70b4e.svg";
export { ForwardRef as ReactComponent };